<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleFormSubmit)">

      <div class="row">
        <div class="col-md-12">

          <fieldset class="form-group p-3 border">

            <legend class="w-auto px-2"><i class="fa fa-info-circle" aria-hidden="true"></i> Account Information</legend>

              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="id_role">Role</label>
                  <select id="id_role" class="form-control" v-model="user.role_id" @change="handleRolesSelect">
                    <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                  </select>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="id_sku">Username</label>
                  <input type="text" class="form-control" id="id_name" placeholder="Username" v-model="user.name" />
                  <div class="text-danger">
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="id_password">Password</label>
                  <input type="password" class="form-control" id="id_password" placeholder="Password" v-model="user.passwordNew" />
                  <small id="id_passwordHelpBlock" class="form-text text-muted">At least 12 characters long and a combination of uppercase letters, lowercase letters, numbers, and symbols.</small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="id_confirm_password">Confirm Password</label>
                  <input type="password" class="form-control" id="id_confirm_password" placeholder="Confirm Password" v-model="user.passwordConfirm" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="id_email">Email</label>
                  <input type="text" class="form-control" id="id_email" placeholder="Email" v-model="user.email"  />
                </div>
              </div>

          </fieldset>

        </div>
        <!-- close col-md-12 -->
      </div>
      <!-- close row -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary btn-icon-splitfloat-right">{{ type }}</button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import UserApiRequest from '@/components/ApiRequester/Users.js';
import RoleApiRequest from '@/components/ApiRequester/Role.js';
//import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend, ValidationObserver } from 'vee-validate';

export default {
  name: 'UserForm',
  props: {
    type: {
      required: true,
      type: String,
      validator: (val) => ['Create', 'Update'].includes(val),
    },
    item: {
      required: false,
      type: Object,
      default: () => null,
    },
  },
  components: {
    ValidationObserver,
    //ValidationProvider
  },
  data: () => ({
    roles: {},
    user: {
      id: null,
      name: 'test',
      role_id: 3,
      password: '',
      passwordNew: 'passwordpassword',        
      passwordConfirm: 'passwordpassword',      
      email: '', 
    },

  }),
  created() {

    if (this.$props.item !== null) {
      this.user = Object.assign(this.user, {
        id: this.$props.item.id,
        name: this.$props.item.name,
        role_id: this.$props.item.role_id,
        password: this.$props.item.password,
        email: this.$props.item.email,
      });
    }

    extend('required', {
      validate (value) {
        return {
          required: true,
          valid: ['', null, undefined].indexOf(value) === -1
        }
      },
      computesRequired: true,
      message: 'This field is required',
    });
  },
  
  mounted() {

    document.getElementById('loader').classList.add('active');
    Promise.all([
      this.fetchRoles(),
    ]).then(([rolesResources]) => {
      this.roles = rolesResources;
      document.getElementById('loader').classList.remove('active');
    }).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });

   },

  methods: {

    handleRolesSelect(role) {
      this.role_id = role.id;
    },

    handleFormSubmit() {

      const ApiRequester = new UserApiRequest();

      if (this.user.passwordNew !== 'passwordpassword'){
        this.user.password = this.user.passwordNew
      }

      let payload = { data: this.user };  

      switch (this.$props.type) {
        case 'Create':
          payload = Object.assign(payload, { method: 'POST' });
          break;
        case 'Update':
          payload = Object.assign(payload, { method: 'PUT' });
          break;
      }

      document.getElementById('loader').classList.add('active');

      ApiRequester.store(payload).then(() => {
        document.getElementById('loader').classList.remove('active');
        this.$emit('submit');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      })
    },

    fetchRoles() {
      const ApiRequester = new RoleApiRequest();
      return ApiRequester.all().then((response) => response.data.roles);
    }

  },
};
</script>

<style lang="scss" scoped>
.error {
  border-color: red;
}
</style>
